import { useState, useEffect, useCallback } from 'react';
import { GroupTenant, Trips } from 'types/commonTypes';
import { useQuery } from '@apollo/client';
import { GET_TENANT_INFO_BY_USER_ID } from 'graphql/service';
import { useRecoilState } from 'recoil';
import { reloadTrips } from  'states/CommonStates/atoms';

const debug = false;


export const useLoadTrips = () => {


  const [trips, setTrips] = useState<Trips>({})
  const [paymentCards, setPaymentCards] = useState<any[]>([]);

  const userId = localStorage.getItem('userId')
  
  const [reload, setReload] = useRecoilState(reloadTrips);

  if (debug) {
    console.log ("User Id to feach bookings =", userId);
  }


  useEffect(() => {
    if (debug) {
        console.log ('[useLoadTrips]paymentCards:', paymentCards);
    }
  }, [paymentCards]);

  const { loading, error, refetch } = useQuery(
    GET_TENANT_INFO_BY_USER_ID,
    {
      skip: !userId, // Skip, if no userID
      variables: { userId },
      onCompleted: (tenantInfoData) => {
        const tenant = tenantInfoData?.tenantByUserID;
        const groups = tenant?.groups || [];
        const trips: Trips = {}
        groups.forEach((groupTenant: GroupTenant)=>{
          if(groupTenant.group) {
            const group = groupTenant.group
            trips[group.groupId] = group
          }
        })
        setTrips(trips)
        setPaymentCards(tenant?.paymentCards || []);
      },
      onError: (error) => {
        const content = error.message
        console.log(content)
      }
    }
  )

  const refetchFromNetwork = useCallback(async () => {
    try {
      const { data } = await refetch({ fetchPolicy: 'network-only' });
      if (data) {
        const groups = data.tenantByUserID.groups;
        const newTrips: Trips = {};
        groups.forEach((groupTenant: GroupTenant) => {
          if (groupTenant.group) {
            const group = groupTenant.group;
            newTrips[group.groupId] = group;
          }
        });
        setTrips(newTrips); // Updating `trips`
        setPaymentCards(data.tenantByUserID.paymentCards || []);

      }
    } catch (err) {
      if (debug) {
        console.error("Refetch error:", err);
      }
    }
  }, [refetch]);


  useEffect(() => {
    if (reload) {
      (async () => {
        await refetchFromNetwork(); // reloading data
        setReload(false); // set atom to `false`
      })();
    }
  }, [reload, refetchFromNetwork, setReload]);

  return {
    trips,
    loading,
    error,
    paymentCards,
    refetch: refetchFromNetwork, // Return the wrapped refetch
  }
}
